import React, { FC } from "react";

import { ContentUnavailable } from "@/components/ContentUnavailable";

import OfferMessageNotReceivedImage from "@assets/image/offer_message_not_received.png";

export const PROPOSAL_NOT_FOUND_TITLE = "このメッセージは現在表示できません";
export const PROPOSAL_NOT_FOUND_DESCRIPTION =
  "プランナーの提携終了や退会、メッセージの削除などにより、\n表示できなくなった可能性があります。";
export const PROPOSAL_NOT_FOUND_BACK_LABEL = "メッセージ一覧へ戻る";

interface ProposalNotFoundProps {
  // 一覧への導線。PC 右ペインのように一覧が同時に見えている場合は省略する
  onBackToList?: () => void;
}

/** 非表示・退会・削除済みなどでオファー詳細を取得できない場合の案内。 */
export const ProposalNotFound: FC<ProposalNotFoundProps> = ({ onBackToList }) => (
  <ContentUnavailable
    title={PROPOSAL_NOT_FOUND_TITLE}
    description={PROPOSAL_NOT_FOUND_DESCRIPTION}
    imageUrl={OfferMessageNotReceivedImage}
    testId="proposal-not-found"
    onBack={onBackToList}
    backLabel={PROPOSAL_NOT_FOUND_BACK_LABEL}
  />
);
